export default {
  data() {
    return {
      // 搜索的关键字
      form: {
        name: '',
        phone: '',
        idcard: ''
      },
      // 学员列表
      students: [],
    }
  },

  methods: {

    // 处理点击搜索学员按钮
    handleClick() {
      if (this.form.name !== '' || this.form.phone !== '' || this.form.idcard !== '') {
        this.search()
      } else {
        this.$message({
          type: 'error',
          message: '请输入搜索关键字'
        })
      }
    },

    // 搜索学员
    search() {
      this.$post('purchased/get_purchased_detail', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 999,
        user_name: this.form.name,
        phone: this.form.phone,
        idcard: this.form.idcard
      }).then(res => {
        this.students = res.data.result.data
      })
    },

    // 点击处理异常按钮
    async handleException(purchased_id, rate, project_id) {
      let project = await this.getProject(project_id)
      let newRate = this.getRate(project)
      this.handleRate(purchased_id, JSON.parse(rate), newRate)
    },

    // 根据项目id获取项目的组成部分
    getProject(project_id) {
      return this.$post('project_tasks/search_group_by_task', {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        project_id: project_id
      })
    },

    // 获取新的rate
    getRate(data) {
      let newRate = ''
      newRate = data.data.result.data.map((res) => {
        for (let i = 0; i < res.task_activities.length; i++) {
          res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
        }
        return res
      })
      return newRate
    },

    // 处理rate
    handleRate(purchased_id, oldRate, newRate) {
      for (let i = 0; i < oldRate.length; i++) {
        oldRate[i].sort = 1
        if (this.$isAbnormal(oldRate[i].taskState)) {
          oldRate[i].taskState = 1
        }

        for (let j = 0; j < oldRate[i].task_activities.length; j++) {
          oldRate[i].task_activities[j].activite_sort = 1
          if (this.$isAbnormal(oldRate[i].task_activities[j].activeState)) {
            oldRate[i].task_activities[j].activeState = 1
          }

          for (let k = 0; k < oldRate[i].task_activities[j].resources.length; k++) {

            for (let x = 0; x < oldRate[i].task_activities[j].resources[k].items.length; x++) {
              oldRate[i].task_activities[j].resources[k].items[x].resources[0] =
                newRate[i].task_activities[j].resources[k].items[x].resources[0]

              oldRate[i].task_activities[j].resources[k].items[x].type =
                newRate[i].task_activities[j].resources[k].items[x].type

              if (oldRate[i].task_activities[j].resources[k].items[x].state == 2 &&
                oldRate[i].task_activities[j].resources[k].items[x].progress != 1) {
                oldRate[i].task_activities[j].resources[k].items[x].progress = '1.00'
              }
            }
          }
        }
      }
      this.updateRate(purchased_id, oldRate)
    },

    // 更新rate
    updateRate(purchased_id, rate) {
      this.$post('purchased/sumbitRate', {
        token: this.$store.state.authority_management,
        id: purchased_id,
        rate: JSON.stringify(rate)
      }).then(res => {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
      })
    }
  }
}